import type { RequestComponentProps } from 'modules/notifications/pages/RequestsPage/RequestItems/RequestItem/base'

import BasePendingApproval from '../BasePendingApprovals'

const CardApprovals = ({ request, index, compact, removeRequestById }: RequestComponentProps) => {
  return (
    <BasePendingApproval
      request={request}
      index={index}
      compact={compact}
      removeRequestById={removeRequestById}
    />
  )
}

export default CardApprovals
